

























































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "../../lib/ajax";
import RegionSelect from "../../components/region-select.vue";
import EditOffer from "@/views/supplierOffer/components/edit-offer.vue";
import TabsHeader from "@/components/tabs-header.vue";

import moment from "moment";
class PageCourtRequest extends PageRequest {
  courtId: number = null;
  verifyState: number = null;
  offerDateTypeId:number=null;
  tabValue:number=1;

}

@Component({
  components: { RegionSelect, EditOffer,TabsHeader },
})
export default class MyOffers extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  showDetail() {
    this.detailModalShow = true;
  }
  //filters
  pagerequest: PageCourtRequest = new PageCourtRequest();

  detailModalShow: boolean = false;
  editModalShow: boolean = false;

  copying: boolean = false;
  copyingSelect: boolean = false;
  // dateTypes:Array<any>=[];

  regions = [];

  courtList = [];
   headTypes:Array<Object>=[{
    label:'上月报价',
    value:0
  },{
    label:'本月报价',
    value:1
  },{
    label:'下月报价',
    value:2
  }]

  selectedCourtIds: Array<number> = new Array<number>();

  get list() {
    return this.$store.state.supplierOfferItem.list;
  }
  get loading() {
    return this.$store.state.supplierOfferItem.loading;
  }
  create() {
    this.detailModalShow = true;
  }
  selectionChange(e) {
    if (e.length > 0) {
      this.selectedCourtIds = [];
      for (const it of e) {
        this.selectedCourtIds.push(it.id);
      }
    }
  }
   async updateInfo(row) {
    console.log(row, "row");
    await this.$store.dispatch({
      type: "supplierOfferItem/update",
      data: row,
    });
    this.$Message.success({
      content: "修改成功",
    });
  }
  async copyLastMonth() {
    this.copying = true;
    try {
      await Ajax.post("/api/services/app/supplierOfferItem/CopyLastMonth", {});
      this.$Message.success({
        content: "复制成功！",
        duration: 3,
      });
      this.getpage();
    } catch (error) {
      this.copying = false;
    }
    this.copying = false;
  }
  async copySelectLastMonth() {
    this.copyingSelect = true;
    //console.log(this.selectedCourtIds);
    try {
      await Ajax.post("/api/services/app/supplierOfferItem/CopyLastMonth", {
        idList: this.selectedCourtIds,
      });
      this.$Message.success({
        content: "复制成功！",
        duration: 3,
      });
      this.getpage();
    } catch (error) {
      this.copyingSelect = false;
    }

    this.copyingSelect = false;
  }
  pageChange(page: number) {
    this.$store.commit("supplierOfferItem/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("supplierOfferItem/setPageSize", pagesize);
    this.getpage();
  }
  handleSpan({ row, column, rowIndex, columnIndex }) {
    // 只处理第一列
    if (columnIndex !== 0) {
      return {
        rowspan: 1,
        colspan: 1,
      };
    }

    const currentCourtName =
      row.timeSlot.offerDateSlot.supplierOffer.court.name;
    let rowspan = 1;

    // 查看下一行是否也是相同的球场名称
    for (let i = rowIndex + 1; i < this.list.length; i++) {
      if (
        this.list[i].timeSlot.offerDateSlot.supplierOffer.court.name ===
        currentCourtName
      ) {
        rowspan++;
      } else {
        break;
      }
    }
    // 如果当前行不是合并组的第一行，则不显示该单元格
    if (
      rowIndex > 0 &&
      this.list[rowIndex - 1].timeSlot.offerDateSlot.supplierOffer.court
        .name === currentCourtName
    ) {
      return {
        rowspan: 0,
        colspan: 0,
      };
    }

    // 返回合并属性
    return {
      rowspan,
      colspan: 1,
    };
  }
  search() {
    this.$store.commit("supplierOfferItem/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "supplierOfferItem/getAllFlat",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.supplierOfferItem.pageSize;
  }
  get totalCount() {
    return this.$store.state.supplierOfferItem.totalCount;
  }
  get currentPage() {
    return this.$store.state.supplierOfferItem.currentPage;
  }
  get offerDateTypeDics() {
    return this.$store.state.common.offerDateTypeDic;
  }

  get dateTypes(){
    console.log(this.$store.state.offerDateType.list,'this.$store.state.offerDateType.list');
    return this.$store.state.offerDateType.list;
  }
  get paymethods() {
    return this.$store.state.common.paymethodsDic;
  }

  columns = [
    {
      title: "球场名称",
      width: 250,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.timeSlot.offerDateSlot.supplierOffer.court.name
        );
      },
    },
    {
      title: "供应商",
      width: 120,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.timeSlot.offerDateSlot.supplierOffer.supplier.name
        );
      },
    },
    {
      title: "供应商报价",
      key: "offerPrice",
    },
    {
      title: "加利润后价格",
      render: (h: any, params: any) => {
        return h("span", params.row.price);
      },
    },
     {
      title: "vip减免",
      slot: "vipReduction",
    },
    {
      title: "返现金额",
      slot: "cashback",
    },
    {
      title: "预付金",
      render: (h: any, params: any) => {
        return h("span", params.row.amount);
      },
    },
    {
      title: "日期类型",
      render: (h: any, params: any) => {
        return h("span", this.offerDateTypeDics[params.row.offerDateTypeId]);
      },
    },
    {
      title: "开始时间",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          `${params.row.timeSlot.startTime}-${params.row.timeSlot.endTime}`
        );
      },
    },
    {
      title: "开始日期",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          `${moment(params.row.timeSlot.offerDateSlot.startDate).format(
            "YYYY-MM-DD"
          )} - ${moment(params.row.timeSlot.offerDateSlot.endDate).format(
            "YYYY-MM-DD"
          )}`
        );
      },
    },
    {
      title: "支付方式",
      key: "payMethod",
      render: (h: any, params: any) => {
        return h("span", this.paymethods[params.row.payMethod]);
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 80,
      align: "center",
      render: (h, params) => {
        const hasEditPermission = this.hasPermission(
          "Pages.SupplierOfferItems.Edit"
        );
        const hasDeletePermission = this.hasPermission(
          "Pages.SupplierOfferItems.Delete"
        );
        const dropdownItems = [];

        if (hasEditPermission) {
          dropdownItems.push(
            h(
              "DropdownItem",
              {
                props: {
                  name: "edit",
                },
              },
              this.L("Edit")
            )
          );
        }

        if (hasDeletePermission) {
          dropdownItems.push(
            h(
              "DropdownItem",
              {
                props: {
                  name: "delete",
                },
              },
              this.L("Delete")
            )
          );
        }
        return h(
          "Dropdown",
          {
            style: {
              marginLeft: "5px",
            },
            props: {
              placement: "bottom-end",
              transfer: true,
            },
            on: {
              "on-click": async (name) => {
                switch (name) {
                  case "edit":
                    this.$store.commit("supplierOfferItem/edit", params.row);
                    this.edit();
                    break;
                  case "delete":
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: "确定删除该报价吗",
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "supplierOfferItem/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                    break;
                  default:
                    break;
                }
              },
            },
          },
          [
            h(
              "a",
              {
                attrs: {
                  href: "javascript:void(0)",
                },
              },
              [
                this.L("Actions"),
                h("Icon", {
                  props: {
                    type: "ios-arrow-down",
                  },
                }),
              ]
            ),
            h(
              "DropdownMenu",
              {
                slot: "list",
              },
              dropdownItems
            ),
          ]
        );
      },
    },
  ];
  async created() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
    this.getpage();
    await this.$store.dispatch({
      type:'offerDateType/getAll',
      data:{
        skipCount:0,
        maxResultCount:200
      }
    })
  }
}
